// Globals
import dayjs from 'dayjs';

// Models
import { IProduct } from '@/models/products.model';

export const normalizeProductValues = (initialValues: IProduct) => {
  const normalizedData = {
    ...initialValues,
    product_id: initialValues?.id,
    published: !!initialValues?.published ? '1' : '0',
    date_from: dayjs(initialValues?.date_from),
    date_to: dayjs(initialValues?.date_to),
  };
  return normalizedData;
};
